import CoacheeSessionGroup from '@efdigital/ll-xceed-v2/components/coaching/coach/coachee-session-group.gts';
import type { CoachingCoachCoacheesCoacheeModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees/coachee';
import type { TOC } from '@ember/component/template-only';

interface CoachingCoachCoacheesCoacheeCanceledSignature {
  Args: {
    model: CoachingCoachCoacheesCoacheeModel;
    controller: unknown;
  };
}

<template>
  <CoacheeSessionGroup
    @sessions={{@model.summary.cancelled}}
    @coach={{@model.coach}}
    @emptyMessage="No canceled sessions with this coachee."
  />
</template> satisfies TOC<CoachingCoachCoacheesCoacheeCanceledSignature>;
